// extracted by mini-css-extract-plugin
export default {"code":"Q_dW"};